import {
  OverlayPreviewOptionsType,
  RedactionConfig,
} from '@common/state/modules/mediaDetails/models';
import {
  UDR_COLOR,
  HEAD_COLOR,
  PLATE_COLOR,
  LAPTOP_COLOR,
  BLUR_LEVEL_COEFFS,
  OUTLINE_COLOR,
  NOTEPAD_COLOR,
  CARD_COLOR,
  PERSON_COLOR,
} from '@helpers/constants';
import { IntRange } from '@utils';

const previewStyles = {
  black_fill: {
    backgroundColor: '#000000',
    borderWidth: '2px',
    borderStyle: 'solid',
    borderColor: '#000000',
  },
  outline: {
    backgroundColor: 'transparent',
    borderWidth: '3px',
    borderStyle: 'solid',
    borderColor: OUTLINE_COLOR,
  },
  none: {
    display: 'none',
  },
};

const outlineStylesByObjectType = {
  head: {
    backgroundColor: `${HEAD_COLOR}26`,
    borderWidth: '2px',
    borderStyle: 'solid',
    borderColor: HEAD_COLOR,
  },
  udr: {
    backgroundColor: `${UDR_COLOR}26`,
    borderWidth: '2px',
    borderStyle: 'solid',
    borderColor: UDR_COLOR,
  },
  license: {
    backgroundColor: `${PLATE_COLOR}26`,
    borderWidth: '2px',
    borderStyle: 'solid',
    borderColor: PLATE_COLOR,
  },
  vehicle: {
    backgroundColor: `${PLATE_COLOR}26`,
    borderWidth: '2px',
    borderStyle: 'solid',
    borderColor: PLATE_COLOR,
  },
  laptop: {
    backgroundColor: `${LAPTOP_COLOR}26`,
    borderWidth: '2px',
    borderStyle: 'solid',
    borderColor: LAPTOP_COLOR,
  },
  notepad: {
    backgroundColor: `${NOTEPAD_COLOR}26`,
    borderWidth: '2px',
    borderStyle: 'solid',
    borderColor: NOTEPAD_COLOR,
  },
  card: {
    backgroundColor: `${CARD_COLOR}26`,
    borderWidth: '2px',
    borderStyle: 'solid',
    borderColor: CARD_COLOR,
  },
  person: {
    backgroundColor: `${PERSON_COLOR}26`,
    borderWidth: '2px',
    borderStyle: 'solid',
    borderColor: PERSON_COLOR,
  },
  disabled: {
    backgroundColor: 'rgba(80, 80, 80, 0.15)',
  },
};

const getIndividualBlurStyle = (
  blurValue: IntRange<0, 10>,
  { width, height }: { width: number; height: number }
) => {
  const blurPx = Math.floor(
    BLUR_LEVEL_COEFFS[blurValue] * Math.max(width, height)
  );
  // TODO investigate if Discretizing over range of blurPx in advance is more efficient
  return {
    backdropFilter: `blur(${blurPx}px)`,
    backgroundColor: 'unset',
    borderWidth: '0px',
    borderColor: 'transparent',
  };
};

export const stagedBoundingBoxStyles = {
  ...outlineStylesByObjectType.udr,
};

export const getRedactedOverlayStyle = (
  redactionConfig: RedactionConfig,
  dimensions: { width: number; height: number }
) => {
  switch (redactionConfig.fillType) {
    case 'black_fill':
      return previewStyles.black_fill;
    case 'outline':
      return previewStyles.outline;
    default: // blur
      return getIndividualBlurStyle(
        redactionConfig.blurLevel || 10,
        dimensions
      );
  }
};

export const getOverlayStyles = (overlayType: OverlayPreviewOptionsType) => {
  switch (overlayType) {
    case 'black_fill':
      return {
        head: previewStyles.black_fill,
        udr: previewStyles.black_fill,
        licensePlate: previewStyles.black_fill,
        vehicle: previewStyles.black_fill,
        laptop: previewStyles.black_fill,
        notepad: previewStyles.black_fill,
        card: previewStyles.black_fill,
        disabled: outlineStylesByObjectType.disabled,
        person: previewStyles.black_fill,
      };
    case 'none':
      return {
        head: previewStyles.none,
        udr: previewStyles.none,
        licensePlate: previewStyles.none,
        vehicle: previewStyles.none,
        laptop: previewStyles.none,
        notepad: previewStyles.none,
        card: previewStyles.none,
        disabled: outlineStylesByObjectType.disabled,
        person: previewStyles.none,
      };
    default:
      // assumes its outline
      return {
        head: outlineStylesByObjectType.head,
        udr: outlineStylesByObjectType.udr,
        licensePlate: outlineStylesByObjectType.license,
        vehicle: outlineStylesByObjectType.vehicle,
        laptop: outlineStylesByObjectType.laptop,
        notepad: outlineStylesByObjectType.notepad,
        card: outlineStylesByObjectType.card,
        disabled: outlineStylesByObjectType.disabled,
        person: outlineStylesByObjectType.person,
      };
  }
};
